module.exports = __webpack_public_path__ + "img/BJYX_IOS.424d19e8.png";